import { render, staticRenderFns } from "./freezer-group.vue?vue&type=template&id=1a2b55d8&scoped=true&"
import script from "./freezer-group.vue?vue&type=script&lang=js&"
export * from "./freezer-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b55d8",
  null
  
)

export default component.exports